/* Auranth cart: shipping protection switch, remove link, cross-sell and summary.

   The theme redraws [data-products] from /cart?view=ajax after every change (event cart:build). This file
   watches that node and keeps everything outside it in step, so it never needs a redraw of its own.
   It is loaded from snippets/cart-drawer.liquid on every page, whatever the cart holds. */
(function () {
  'use strict';

  var cfg = window.jlCart || {};
  var VARIANT_ID = Number(cfg.variantId) || 0;
  var OPT_OUT_KEY = 'jl_protection_opt_out';
  var REDRAW_TIMEOUT_MS = 6000;
  var SAFETY_UNLOCK_MS = 15000;

  var busy = 0;
  var safetyTimer = null;
  var waiting = [];
  var lastCount = null;

  function all(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function money(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function post(url, data) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(data)
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok) throw json;
        return json;
      });
    });
  }

  /* The switch stays locked for the whole cycle: cart request, redraw, summary. */
  function paintBusy() {
    var locked = busy > 0;
    all('.jl-pp__input').forEach(function (input) { input.disabled = locked; });
    all('.jl-pp__switch').forEach(function (label) { label.classList.toggle('is-disabled', locked); });
    all('.jl-cart-summary').forEach(function (summary) { summary.classList.toggle('is-loading', locked); });
  }

  function setBusy(on) {
    busy = Math.max(0, busy + (on ? 1 : -1));
    if (safetyTimer) { clearTimeout(safetyTimer); safetyTimer = null; }
    if (busy > 0) {
      safetyTimer = setTimeout(function () { safetyTimer = null; busy = 0; paintBusy(); }, SAFETY_UNLOCK_MS);
    }
    paintBusy();
  }

  /* Asks the theme to redraw and resolves once the new markup is in (or after a timeout). */
  function redraw() {
    return new Promise(function (resolve) {
      var done = false;
      function finish() { if (!done) { done = true; resolve(); } }
      waiting.push(finish);
      setTimeout(finish, REDRAW_TIMEOUT_MS);
      document.dispatchEvent(new CustomEvent('cart:build'));
    });
  }

  function run(request) {
    setBusy(true);
    return request()
      .catch(function (error) { console.error('Cart update failed:', error); })
      .then(redraw)
      .then(function () { setBusy(false); });
  }

  /* update.js sets the quantity outright, so this adds, removes and repairs a doubled line alike. */
  function setProtection(quantity) {
    var updates = {};
    updates[VARIANT_ID] = quantity;
    return post(cfg.updateUrl || '/cart/update.js', { updates: updates });
  }

  function optedOut() {
    try { return sessionStorage.getItem(OPT_OUT_KEY) === '1'; } catch (e) { return true; }
  }

  function rememberChoice(isOn) {
    try {
      if (isOn) sessionStorage.removeItem(OPT_OUT_KEY); else sessionStorage.setItem(OPT_OUT_KEY, '1');
    } catch (e) {}
  }

  /* Runs after every redraw, and once for a cart page that Liquid has already filled. */
  function sync(items) {
    var count = parseInt(items.getAttribute('data-count'), 10) || 0;
    var protection = parseInt(items.getAttribute('data-jl-protection'), 10) || 0;
    var savings = parseInt(items.getAttribute('data-jl-savings'), 10) || 0;
    var scope = items.closest('form') || document;
    var isFirst = lastCount === null;
    var grew = !isFirst && count > lastCount;

    all('.jl-pp__input', scope).forEach(function (input) { input.checked = protection > 0; });
    all('[data-jl-savings-row]', scope).forEach(function (row) {
      var value = row.querySelector('[data-jl-savings]');
      if (value) value.innerHTML = '-' + money(savings);
      row.classList.toggle('hide', savings <= 0);
    });
    all('.cart-link__bubble').forEach(function (bubble) {
      bubble.classList.toggle('cart-link__bubble--visible', count > 0);
    });

    var finished = waiting;
    waiting = [];
    finished.forEach(function (finish) { finish(); });
    paintBusy();
    lastCount = count;

    /* The cart page draws its empty state in Liquid only. */
    if (count === 0 && protection === 0 && !isFirst && document.body.classList.contains('template-cart')) {
      window.location.reload();
      return;
    }

    if (!VARIANT_ID) return;

    if (count === 0 && protection > 0) {
      run(function () { return setProtection(0); });
    } else if (protection > 1) {
      run(function () { return setProtection(1); });
    } else if (cfg.auto && protection === 0 && count > 0 && ((isFirst && !optedOut()) || grew)) {
      /* Automatic mode: on arrival with a filled cart unless switched off this session, and whenever a product is added. */
      run(function () { return setProtection(1); });
    }
  }

  function watch() {
    all('[data-products]').forEach(function (node) {
      new MutationObserver(function () {
        var items = node.querySelector('.cart__items');
        if (items) sync(items);
      }).observe(node, { childList: true });

      var items = node.querySelector('.cart__items');
      if (items) sync(items);
    });
  }

  document.addEventListener('change', function (evt) {
    var input = evt.target;
    if (!input.classList || !input.classList.contains('jl-pp__input')) return;

    /* A change that slipped through while an update is running. */
    if (busy > 0) { input.checked = !input.checked; return; }

    var isOn = input.checked;
    rememberChoice(isOn);
    all('.jl-pp__input').forEach(function (other) { other.checked = isOn; });
    run(function () { return setProtection(isOn ? 1 : 0); });
  });

  document.addEventListener('click', function (evt) {
    if (!evt.target.closest) return;

    var remove = evt.target.closest('.cart__remove a');
    if (remove) {
      var line = remove.closest('.cart__item');
      if (!line || !line.getAttribute('data-key')) return;
      evt.preventDefault();
      if (line.classList.contains('is-removing')) return;
      line.classList.add('is-removing');
      run(function () { return post(theme.routes.cartChange, { id: line.getAttribute('data-key'), quantity: 0 }); });
      return;
    }

    var add = evt.target.closest('.jl-xsell__add');
    if (add) {
      evt.preventDefault();
      if (add.classList.contains('is-loading')) return;
      var card = add.closest('.jl-xsell__card');
      var select = card && card.querySelector('.jl-xsell__select');
      var id = Number(select ? select.value : add.getAttribute('data-variant'));
      if (!id) return;
      add.classList.add('is-loading');
      run(function () { return post(theme.routes.cartAdd, { id: id, quantity: 1 }); });
    }
  });

  /* Cross-sell dots follow the carousel. scroll does not bubble, hence the capture. */
  document.addEventListener('scroll', function (evt) {
    var track = evt.target;
    if (!track.classList || !track.classList.contains('jl-xsell__track')) return;

    var dots = all('.jl-xsell__dots span', track.parentNode);
    if (!dots.length) return;

    var nearest = 0;
    var distance = Infinity;
    var start = track.getBoundingClientRect().left;
    all('.jl-xsell__card', track).forEach(function (card, index) {
      var d = Math.abs(card.getBoundingClientRect().left - start);
      if (d < distance) { distance = d; nearest = index; }
    });
    dots.forEach(function (dot, index) { dot.classList.toggle('is-active', index === nearest); });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
